var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.54 0 6.68 1.22 9.16 3.6l6.84-6.84C35.86 2.38 30.47 0 24 0 14.62 0 6.48 5.38 2.56 13.22l7.98 6.19C12.44 13.09 17.77 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M46.1 24.5c0-1.59-.14-3.12-.4-4.6H24v9.02h12.44c-.54 2.9-2.18 5.36-4.64 7.02l7.18 5.58C43.91 37.09 46.1 31.32 46.1 24.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M10.54 28.59c-.48-1.43-.76-2.95-.76-4.59s.28-3.16.76-4.59l-7.98-6.19C.92 16.98 0 20.36 0 24s.92 7.02 2.56 10.78l7.98-6.19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M24 48c6.48 0 11.86-2.14 15.82-5.82l-7.18-5.58c-2 1.34-4.56 2.14-8.64 2.14-6.23 0-11.56-3.59-13.46-8.91l-7.98 6.19C6.48 42.62 14.62 48 24 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.e17ffe8dcd163c7b67e380a9b3286151.svg";
export { ForwardRef as ReactComponent };